var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationWalletAlt = function SvgSimpleIllustrationWalletAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 270,
    height: 280,
    viewBox: "0 0 30 44",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.797 22.848H2.945a2.06 2.06 0 0 0-2.059 2.059v15.575a2.06 2.06 0 0 0 2.06 2.06h23.85a2.06 2.06 0 0 0 2.06-2.06V24.907a2.06 2.06 0 0 0-2.06-2.06Z",
    fill: "#D18000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.471 26.359v-3.613H2.632s-1.746.637-1.746 1.85v1.841l4.583-.078h.002ZM24.562 22.585v3.928h4.163v-1.922s-.4-1.746-1.615-1.746c-1.215 0-2.548-.263-2.548-.263v.003Z",
    fill: "#780505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.718.824H5.156v25.69h19.562V.824Z",
    fill: "#00B268"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.084 32.756v-2.948s.084-1.347-1.137-1.347H6.79s-1.137 0-1.137 1.095v3.119l20.431.084v-.003Z",
    fill: "#FCDCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16 28.625H4.39s-.715-.21-.757 1.137L3.55 32.46l2.107.21V29.55l.506-.928-.003.003Z",
    fill: "#FBCCFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.072 30.184H8.308v2.358h3.764v-2.358Z",
    fill: "#F9B5FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 32.487v-2.794c0-.69.559-1.252 1.252-1.252H24.86c.69 0 1.252.56 1.252 1.252v2.962",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.137 32.429v-2.19h3.876v2.246M14.036 30.46h3.875M20.102 30.46h3.876M14.036 31.59h3.875M3.588 32.487v-2.794c0-.69.559-1.252 1.252-1.252h4.085",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.874 23.41c2.425 0 4.39-2.992 4.39-6.683 0-3.692-1.965-6.684-4.39-6.684-2.424 0-4.39 2.992-4.39 6.684 0 3.691 1.966 6.683 4.39 6.683ZM8.405 5.57a1.35 1.35 0 1 0 0-2.699 1.35 1.35 0 0 0 0 2.7ZM21.513 5.59a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7Z",
    fill: "#5BE3AA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.217 26.357V1.105h19.356v25.12",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.897 23.628c2.446 0 4.428-3.07 4.428-6.857 0-3.787-1.982-6.857-4.428-6.857-2.446 0-4.43 3.07-4.43 6.857 0 3.787 1.984 6.857 4.43 6.857ZM21.513 5.791a1.548 1.548 0 1 0 0-3.096 1.548 1.548 0 0 0 0 3.096ZM8.414 5.791a1.548 1.548 0 1 0 0-3.096 1.548 1.548 0 0 0 0 3.096ZM8.235 26.357V7.328M21.647 7.328v19.088M11.655 3.988h6.595M18.247 4.219a3.12 3.12 0 0 0 3.118 3.118c.064 0 .132 0 .196-.005M11.658 4.219A3.12 3.12 0 0 1 8.54 7.337c-.064 0-.131 0-.196-.005",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.771 22.64H26.6a2.259 2.259 0 0 1 2.258 2.258v15.598a2.259 2.259 0 0 1-2.258 2.257H3.04a2.259 2.259 0 0 1-2.258-2.257V24.898a2.259 2.259 0 0 1 2.258-2.257h1.984M.783 26.41h27.97M.783 33.008h27.97",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSimpleIllustrationWalletAlt;